export default __webpack_public_path__ + "static/media/ico-key.8ae87b73.svg";